export default "__VITE_ASSET__DcDOUAOc__"